import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-contact-form',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent {
    private readonly isBrowser: boolean;
    contactForm: FormGroup;
    @ViewChild('recaptchaContainer', { static: false })
    recaptchaContainer!: ElementRef;
    captchaToken: string = '';
    showSuccessMessage = false;
    isSubmitting = false;
    private captchaRendered = false;
    private captchaScriptRequested = false;

    constructor(private formBuilder: FormBuilder, private http: HttpClient, @Inject(PLATFORM_ID) platformId: object) {
        this.isBrowser = isPlatformBrowser(platformId);
        this.contactForm = this.formBuilder.group({
            name: ['', Validators.required],
            lastname: [''],
            email: ['', [Validators.required, Validators.email]],
            phone: ['', Validators.required],
            bookingReferenceNumber: [''],
            aboutQuestion: ['', Validators.required],
            message: ['', Validators.required],
        });
    }

    ngAfterViewInit(): void {
        if (!this.isBrowser) return;
    }

    private loadRecaptchaScript(): void {
        if (this.captchaScriptRequested) return;
        this.captchaScriptRequested = true;

        const w = window as any;
        if (w.grecaptcha) return;
        if (document.getElementById('recaptcha-api-js')) return;

        const script = document.createElement('script');
        script.id = 'recaptcha-api-js';
        script.src = 'https://www.google.com/recaptcha/api.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    }

    onFormInteraction(): void {
        if (!this.isBrowser || this.captchaRendered) return;
        this.loadRecaptchaScript();
        this.renderCaptcha();
    }

    onSubmit(): void {
        this.onFormInteraction();
        if (this.contactForm.invalid) return;
        this.verifyCaptcha();
        this.isSubmitting = true;

        const url = environment.apiURL + '/api/form';

        const formData = {
            name: this.contactForm.value.name,
            lastname: this.contactForm.value.lastname,
            email: this.contactForm.value.email,
            phone: this.contactForm.value.phone,
            bookingReferenceNumber:
                this.contactForm.value.bookingReferenceNumber,
            aboutQuestion: this.contactForm.value.aboutQuestion,
            message: this.contactForm.value.message,
        };

        this.http
            .post(url, formData, {
                headers: { 'Content-Type': 'application/json' },
            })
            .pipe(
                finalize(() => {
                    this.isSubmitting = false;
                })
            )
            .subscribe({
                next: () => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Thank you!',
                        text: 'Our representatives will get in touch shortly',
                    });

                    this.showSuccessMessage = true;
                    this.contactForm.reset();

                    setTimeout(() => {
                        this.showSuccessMessage = false;
                    }, 3000);
                },
                error: (error) => {
                    console.error('Error al enviar el formulario', error);
                    this.isSubmitting = false;
                },
            });
    }

    renderCaptcha(retries = 20): void {
        if (!this.isBrowser || this.captchaRendered) return;
        const w = window as any;

        if (!w.grecaptcha || !w.grecaptcha.render) {
            if (retries > 0) setTimeout(() => this.renderCaptcha(retries - 1), 200);
            return;
        }

        w.grecaptcha.render(this.recaptchaContainer.nativeElement, {
            sitekey: '6Le9FHMrAAAAAHAtdNcal1wPv-X_GpGl82lMJoRc',
            callback: (response: string) => {
                this.captchaToken = response;
            },
            'expired-callback': () => {
                this.captchaToken = '';
            },
        });
        this.captchaRendered = true;
    }

    verifyCaptcha(): void {
        if (this.captchaToken) {
            console.log('Captcha valido');
        }
    }
}
